import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { setValueToStorage } from 'hooks/useLocalStorage';
import { useAppDispatch } from 'hooks/useRedux';
import { setJwtToken, setUser } from 'store/user/userSlice';

import { auth } from 'configuration/firebase';
import { SIGNIN_ROUTE } from 'constants/clientRoutes';
import { LocalStorageKeys } from 'constants/enums';
import { GENERAL_TOAST_OPTIONS } from 'constants/general';

export const useLogout = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const logout = async () => {
    try {
      setIsSubmitting(true);
      await auth.signOut();
      navigate(SIGNIN_ROUTE);
      dispatch(setUser(null));
      dispatch(setJwtToken(null));
      setValueToStorage(LocalStorageKeys.jwtToken, null);
      setValueToStorage(LocalStorageKeys.user, null);
    } catch {
      toast.error(intl.formatMessage({ id: 'error.internalServer' }), GENERAL_TOAST_OPTIONS);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    logout,
  };
};
